import { getAbbrMonth } from '~/utils/day-js.ts'

/**
 * Transforms raw prize-detail lottery entries by formatting their `date` field
 * using the abbreviated month format (`'D MMM YYYY'`).
 * @param {any[]} lotteries - Raw API entries.
 * @param {string} [locale='en'] - BCP 47 locale tag.
 */
export const mapperLotteries = (lotteries, locale = 'en') => {
	return lotteries.map(({ date, ...lottery }) => {
		return {
			...lottery,
			date: getAbbrMonth(date, locale),
		}
	})
}
